// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1pWDE","item":"PaymentsMobile_item__3kbsl","label":"PaymentsMobile_label__3eXoG","amount":"PaymentsMobile_amount__3r0Mt"};